module.exports = __webpack_public_path__ + "img/windstream-logo.3b859674.jpg";